import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IHospitalModel } from './types';

const hospital: IHospitalModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default hospital;
